import ModalRoot from './ModalRoot.jsx';

export default ModalRoot;


// WEBPACK FOOTER //
// ./src/components/ModalRoot/index.jsx